/**
 * API Endpoint Constants
 * Centralized definition of all API endpoints
 *
 * Note: These paths are relative to the baseURL configured in the API client.
 * The /api prefix is part of the baseURL, not the endpoint paths.
 *
 * BRP-671: tenants and their nested licenses live under the Management API
 * namespace (/api/management/tenants/...). The package catalog endpoint stays
 * under /api/tenants/ — it pre-dates the management split.
 */

export const API_ENDPOINTS = {
  // Tenant endpoints (Management API)
  TENANTS: '/management/tenants/',
  TENANT_DETAIL: (id: string) => `/management/tenants/${id}/`,

  // License endpoints (Management API, nested under tenants)
  TENANT_LICENSES: (tenantId: string) => `/management/tenants/${tenantId}/licenses/`,
  LICENSE_DETAIL: (tenantId: string, licenseId: string) => `/management/tenants/${tenantId}/licenses/${licenseId}/`,

  // License package catalog (not part of Management API)
  LICENSE_PACKAGES: '/tenants/packages/',

  // Management dashboard overview
  TENANT_OVERVIEW: '/management/tenants/overview/',
  TENANT_OVERVIEW_DETAILS: '/management/tenants/overview/details/',

  // SSO tenant switch (admin login)
  SWITCH_SSO: (tenantId: string) => `/management/tenants/${tenantId}/support-sso-login/admin-login/`,

  // SSO provider settings for a tenant
  TENANT_SSO_SETTINGS: (tenantId: string) => `/management/tenants/${tenantId}/settings/sso-providers/`,

  // Slack integration config for a tenant
  TENANT_SLACK_CONFIG: (tenantId: string) => `/management/tenants/${tenantId}/settings/slack/`,

  // Impersonate a user
  IMPERSONATE: (tenantId: string, accountId: string) =>
    `/management/tenants/${tenantId}/support-sso-login/impersonate/${accountId}/`,

  // List accounts
  ACCOUNTS: '/management/accounts/',

  // Single account detail
  ACCOUNT_DETAIL: (accountId: string) => `/management/accounts/${accountId}/`,

  // Account status update
  ACCOUNT_STATUS: (accountId: string) => `/management/accounts/${accountId}/status/`,

  // Account statuses enum
  ACCOUNT_STATUSES: '/management/accounts/statuses/',

  // Feature toggle endpoints (Management API)
  FEATURE_TOGGLES: '/management/toggles/',
  FEATURE_TOGGLE_DETAIL: (name: string) => `/management/toggles/${name}/`,
} as const
